module.exports = __webpack_public_path__ + "static/media/XL.1afb7c69.jpg";